// Grid View tab styles - clean, minimal GridView1DetailsView styling
export const gridViewTabStyles = () => ({
    mainDiv: {
        width: '100%',
    },
    detailsTab: {
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        padding: 0,
    },
    sectionHeading: {
        color: 'black',
        fontSize: 16,
        fontFamily: 'Open Sans',
        fontWeight: 600,
        marginBottom: 12,
    },
    sectionBox: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px 34px',
    },
    fieldGroup: {
        flex: '0 0 calc(50% - 17px)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        overflowWrap: 'break-word',
        maxWidth: 'calc(50% - 17px)',
        gap: '4px',
    },
    fieldTitle: {
        color: 'rgba(0, 0, 0, 0.50)',
        fontSize: 12,
        fontFamily: 'Open Sans',
        fontWeight: 600,
    },
    fieldValue: {
        textAlign: 'right',
        color: 'black',
        fontSize: 12,
        fontFamily: 'Open Sans',
        fontWeight: 600,
    },
    // Mobile variants (same as desktop for now)
    fieldGroupMobile: {
        flex: '1 1 calc(50% - 17px)',
        minWidth: 250,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    fieldTitleMobile: {
        color: 'rgba(0, 0, 0, 0.50)',
        fontSize: 14,
        fontFamily: 'Open Sans',
        fontWeight: 600,
    },
    fieldValueMobile: {
        textAlign: 'right',
        color: 'black',
        fontSize: 14,
        fontFamily: 'Open Sans',
        fontWeight: 600,
    },
    detailsTabMobile: {
        display: 'flex',
        flexDirection: 'column',
        gap: 32,
    },
    sectionHeadingMobile: {
        color: 'black',
        fontSize: 18,
        fontFamily: 'Open Sans',
        fontWeight: 600,
    },
    sectionBoxMobile: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px 34px',
    },
    documentGroup: {
        width: '50%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    documentGroupMobile: {
        flex: '1 1 calc(50% - 17px)',
        minWidth: 250,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    documentViewButton: {
        fontFamily: 'Open Sans',
        fontWeight: 600,
        fontSize: 12,
        marginRight: 14,
        color: '#1890ff',
    },
    // Pieces details tab
    pieceDetailsTab: {
        display: 'flex',
        gap: 20,
        height: '100%',
    },
    pieceDetailsTabLeft: {
        flex: '0 0 35%',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        overflow: 'auto',
        padding: '0 12px 12px 12px',
    },
    pieceDetailsTabRight: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
    },
    pieceCardColumnHeader: {
        fontFamily: 'Open Sans',
        fontSize: 14,
        fontWeight: 600,
        color: 'black',
        marginBottom: 12,
        padding: '0 10px 10px 0',
    },
    piecesNumber: {
        display: 'inline-block',
        marginLeft: 8,
        padding: '2px 8px',
        borderRadius: 4,
        backgroundColor: '#f0f0f0',
        fontSize: 14,
        fontWeight: 600,
    },
    pieceCard: {
        padding: 10,
        borderRadius: 8,
        border: '1.5px solid #F0F2F6',
        backgroundColor: 'white',
        cursor: 'pointer',
        transition: 'all 0.3s',
        '&:hover': {
            borderColor: '#165ACE',
        },
    },
    pieceCardUpper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 8,
    },
    pieceCardLeft: {
        display: 'flex',
        flexDirection: 'column',
    },
    pieceCardRight: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        fontSize: 12,
        color: '#000',
    },
    pieceCardSCNS: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    pieceCardStatusLine: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 12,
        color: '#000',
    },
    pieceCardStatus: {
        display: 'inline-block',
        padding: '4px 8px',
        borderRadius: 4,
        backgroundColor: '#E6F7FF',
        color: '#0958D9',
        fontSize: 12,
        fontWeight: 600,
    },
    pieceHeader: {
        fontFamily: 'Open Sans',
        fontSize: 14,
        fontWeight: 600,
        color: 'black',
        display: 'flex',
        alignItems: 'center',
        gap: 4,
    },
    pieceDimensions: {
        fontFamily: 'Open Sans',
        fontSize: 12,
        color: '#000',
        marginTop: 4,
    },
    pieceDescription: {
        fontFamily: 'Open Sans',
        fontSize: 12,
        color: '#999',
        marginTop: 4,
    },
    // Address details tab
    addressDetails: {
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
    },
    addressBox: {
        padding: 10,
        borderRadius: 8,
        border: '1.5px solid #F0F2F6',
        backgroundColor: 'white',
    },
    addressInfoUpper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 0,
    },
    addressInfoUpperLeft: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    addressInfoUpperRight: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        alignItems: 'flex-end',
    },
    addressType: {
        fontFamily: 'Open Sans',
        fontSize: 14,
        fontWeight: 600,
        color: '#666',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
    },
    addressPincode: {
        fontFamily: 'Open Sans',
        fontSize: 16,
        fontWeight: 600,
        color: 'black',
    },
    addressCSC: {
        fontFamily: 'Open Sans',
        fontSize: 14,
        color: '#666',
    },
    addressName: {
        fontFamily: 'Open Sans',
        fontSize: 14,
        fontWeight: 600,
        color: 'black',
    },
    addressContact: {
        fontFamily: 'Open Sans',
        fontSize: 14,
        color: '#666',
    },
    horizontalSeperator: {
        width: '100%',
        height: 1,
        backgroundColor: '#F0F2F6',
    },
    addressInfoLower: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    addressServiceTimeBox: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        fontSize: 14,
        color: '#666',
        marginTop: 8,
    },
    addressVerticalJoin: {
        width: 2,
        height: 6,
        backgroundColor: '#F0F2F6',
        margin: '0 auto',
    },
    verticalSpace: {
        height: 8,
    },
    // Item details (if needed)
    itemDetailsTab: {
        display: 'flex',
        flexDirection: 'column',
    },
    itemSectionBox: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '20px 34px',
    },
    primaryDetailsSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: 32,
    },
});

